import { AbstractModel } from './abstract.model';

export enum UserSessionStatusEnum {
    Active = 1,
    LockedByInactivity = 2,
    TerminatedByNewLogin = 3,
    LoggedOut = 4,
    Expired = 5,
    TerminatedByAdmin = 6,
}

export interface UserSessionModel extends AbstractModel {
    userId?: number;
    userName?: string;
    email?: string;
    fullName?: string;
    roles?: number[];
    createDate: string;
    modifyDate?: string;
    lastActivityAt?: string;
    deviceType?: string;
    deviceId?: string;
    isNewDevice?: boolean;
    operatingSystem?: string;
    clientName?: string;
    clientVersion?: string;
    ipAddress?: string;
    status?: UserSessionStatusEnum;
    finishedAt?: string | null;
}

export interface UserSessionListRequest {
    userId: number;
    deviceType?: string;
    operatingSystem?: string;
    status?: UserSessionStatusEnum;
    dateFrom?: string;
    dateTo?: string;
    page?: number;
    pageSize?: number;
    orderBy?: string;
    reverse?: boolean;
}

export interface UserSessionViewModel extends UserSessionModel {
    deviceMain: string;
    deviceSub: string;
    clientMain: string;
    clientSub: string;
}

export interface UserSessionListResponse {
    data: UserSessionModel[];
    totalCount: number;
}

export interface UserSessionPingResponse {
    status?: UserSessionStatusEnum;
    lastActivityAt?: string;
    expiresInSeconds?: number | null;
}
